import Vue from 'vue'
import dayJs from 'dayjs'

Vue.prototype.$dayjs = dayJs
